import React, {useEffect, useState} from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {UnsubscribeNotifications} from "../services/auth";
import {sweetAlerts} from "../utils/sweet-alerts";

const UnsubscribePage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [loader, setLoader] = useState(true);
	const [status, setStatus] = useState(null);

	useEffect(() => {
		const unsubscribe = async () => {
			const queryParams = new URLSearchParams(location.search);
			const token = queryParams.get("token");

			if (!token) {
				setStatus(false);
				setLoader(false);
				sweetAlerts("error", "Invalid unsubscribe link");
				return;
			}

			setLoader(true);
			try {
				const response = await UnsubscribeNotifications({token});
				setLoader(false);
				if (response?.status) {
					setStatus(true);
					sweetAlerts("success", "You have been unsubscribed from email notifications");
				} else {
					setStatus(false);
					sweetAlerts("error", response.message || "Failed to unsubscribe");
				}
			} catch (error) {
				setLoader(false);
				setStatus(false);
				sweetAlerts("error", error.message || "Failed to unsubscribe");
			}
		};

		unsubscribe();
	}, [location.search]);

	return (
		<div className="modern-login-container">
			<div className="row g-0 h-100">
				{/* Left Side - Logo and Form */}
				<div className="col-lg-6 login-form-section">
					<div className="login-content">
						{/* Header with Logo and Back Link */}
						<div className="login-header">
							<div className="login-logo-container">
								<Link to="/" style={{textDecoration: "none"}}>
									<img src={`${process.env.PUBLIC_URL}/img/header-logo.png`} alt="JobSiteRating Logo" className="login-main-logo" />
								</Link>
							</div>
						</div>

						<div className="login-form-container">
							<div className="row h-100">
								{loader ? (
									<div className="dashboard-page">
										<div className="loading-container">
											<div className="spinner-large"></div>
											<h3>Processing...</h3>
										</div>
									</div>
								) : (
									<div className="col-md-12">
										{status ? (
											<div className="email-verification-banner verified">
												<div className="d-flex align-items-center justify-content-center flex-column">
													<div className="verification-icon mb-3">
														<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
																stroke="currentColor"
																strokeWidth="2"
																strokeLinecap="round"
																strokeLinejoin="round"
															/>
														</svg>
													</div>
													<div className="verification-content text-center">
														<h4 className="mb-3 verification-title">Unsubscribed Successfully</h4>
														<p className="mb-4 verification-message">You have been unsubscribed from JobSiteRating email notifications. You will no longer receive email updates about your dashboard activities.</p>
														<p className="mb-4 text-muted" style={{fontSize: "14px"}}>You can re-enable email notifications anytime from your profile settings.</p>
														<button type="button" className="submit-btn" onClick={() => navigate("/")}>
															Go to Home
														</button>
													</div>
												</div>
											</div>
										) : (
											<div className="email-verification-banner unverified">
												<div className="d-flex align-items-center justify-content-center flex-column">
													<div className="verification-icon mb-3">
														<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
															<path
																d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
																stroke="currentColor"
																strokeWidth="2"
																strokeLinecap="round"
																strokeLinejoin="round"
															/>
														</svg>
													</div>
													<div className="verification-content text-center">
														<h4 className="mb-3 verification-title">Unsubscribe Failed</h4>
														<p className="mb-4 verification-message">We couldn't process your unsubscribe request. The link may be invalid or expired.</p>
														<button type="button" className="submit-btn" onClick={() => navigate("/")}>
															Go to Home
														</button>
													</div>
												</div>
											</div>
										)}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>

				{/* Right Side - Image */}
				<div className="col-lg-6 login-image-section">
					<div className="image-container">
						<img src={`${process.env.PUBLIC_URL}/img/login2.png`} alt="Industrial Construction Site" className="login-background-image" />
					</div>
				</div>
			</div>
		</div>
	);
};

export default UnsubscribePage;















